import { baseApi } from '@/utils/requestConfig'

export function getMembershipFee(cknr) {
  return baseApi.get('/my-membership/payment-info', { headers: { 'oeamtc-identity-cknr': cknr } })
}

export function getContractId(cknr) {
  return baseApi.get('/my-membership/contracts', { headers: { 'oeamtc-identity-cknr': cknr } })
}
